module.exports = __webpack_public_path__ + "img/solnce.b5c5683.png?v=1747202731454";